export default __webpack_public_path__ + "static/media/icon3dcel.83638c5a.png";